import axios from "@/plugins/axios";

// initial state
const state = () => ({
  webinars: [],
  programPhases: [],
  topicTypes: [],
  services: [],
  selectedWebinar: {},
  webinarToEdit: {},
  editWebinarId: -1,
  isWebinarSelected: false,
  isAddingWebinar: false,
  isLoading: false,
  loadingWebinarId: -1,
  toasts: [],
});

const actions = {
  async fetchWebinars({ commit }) {
    try {
      const response = await axios.get("/api/rest/admin/webinar");
      console.log(response.data);
      commit("setWebinars", response.data.webinars);
      commit("setprogramPhases", response.data.programPhases);
      commit("setTopicTypes", response.data.webinarTypes);
      commit("setServices", response.data.services);
    } catch (err) {
      console.log(err);
    }
  },
  async fetchWebinar({ commit }, id) {
    try {
      commit("setIsLoading", true);
      const response = await axios.get(`/api/rest/admin/webinar/${id}`);
      commit("setWebinarToEdit", response.data.webinar);
      commit("setEditWebinarId", id);
      commit("setIsLoading", false);
      commit("setprogramPhases", response.data.programPhases);
      commit("setTopicTypes", response.data.webinarTypes);
    } catch (err) {
      commit("setIsLoading", false);
      console.log(err);
    }
  },
  async addWebinars({ commit, dispatch }, payload) {
    try {
      commit("setIsLoading", true);
      await axios.post("/api/rest/admin/webinar", payload);
      commit("setIsLoading", false);
      commit("setIsAddingWebinar", false);
      commit("addToast", {
        message: "Webinar Added Successfully",
        title: "Success",
        variant: "success",
      });
      dispatch("fetchWebinars");
    } catch (err) {
      commit("setIsLoading", false);
      commit("addErrorToast", {
        error: err.response.data,
      });
    }
  },
  async sendEmailToContacts({ commit }, payload) {
    try {
      await axios.post("/api/rest/admin/companyContact/sendEmail", payload);
      commit("addToast", {
        message: "Emails sent successfully",
        title: "Success",
        variant: "success",
      });
      commit("cancelSelection");
    } catch (err) {
      commit("addErrorToast", {
        errors: err.response.data.errors,
      });
    }
  },
  async updateWebinar({ commit, dispatch }, payload) {
    try {
      commit("setEditWebinarId", -1);
      commit("setLoadingWebinarId", payload.id);
      const data = new FormData();

      if (payload.edited) {
        const keys = Object.keys(payload.edited);
        if (keys.length > 0) {
          Object.keys(payload.edited).map((key) => {
            data.append(key, payload[key]);
          });
        }
      }
      console.log(data);

      await axios.post(`/api/rest/admin/webinar/${payload.id}`, data);
      commit("setLoadingWebinarId", -1);
      commit("addToast", {
        message: "Webinar updated successfully",
        title: "Success",
        variant: "success",
      });
      dispatch("fetchWebinars");
    } catch (err) {
      commit("addErrorToast", {
        errors: err.response.data,
      });
    }
  },
};

const getters = {
  getWebinars(state) {
    return state.webinars;
  },
  getWebinarToEdit(state) {
    return state.webinarToEdit;
  },
  getprogramPhases(state) {
    return state.programPhases;
  },
  getTopics(state) {
    return state.topicTypes;
  },
  getServices(state) {
    return state.services;
  },
  isWebinarSelected(state) {
    return state.isWebinarSelected;
  },
  getSelectedWebinar(state) {
    return state.selectedWebinar;
  },
  getToasts(state) {
    return state.toasts;
  },
  getIsLoading(state) {
    return state.isLoading;
  },
  getIsAddingWebinar(state) {
    return state.isAddingWebinar;
  },
  getLoadingWebinarId(state) {
    return state.loadingWebinarId;
  },
  getEditWebinarId(state) {
    return state.editWebinarId;
  },
};

const mutations = {
  setWebinars(state, webinarsList) {
    state.webinars = webinarsList;
  },
  setWebinarToEdit(state, webinar) {
    state.webinarToEdit = webinar;
  },
  setprogramPhases(state, programPhases) {
    state.programPhases = [
      ...programPhases,
      {
        value: null,
        text: "Not augmented",
      },
    ];
  },
  setTopicTypes(state, topicTypes) {
    state.topicTypes = [
      ...topicTypes,
      {
        value: null,
        text: "No topic",
      },
    ];
  },
  setServices(state, services) {
    state.services = [
      ...services,
      {
        value: null,
        text: "No service",
      },
    ];
  },
  selectWebinar(state, webinar) {
    state.selectedWebinar = webinar;
    state.isWebinarSelected = true;
  },
  cancelSelection(state) {
    state.selectedWebinar = {};
    state.isWebinarSelected = false;
  },
  cancelEdit(state) {
    state.webinarToEdit = {};
    state.editWebinarId = -1;
  },
  clearBanner(state) {
    state.webinarToEdit.banner = null;
  },
  setIsLoading(state, loadingState) {
    state.isLoading = loadingState;
  },
  setLoadingWebinarId(state, id) {
    state.loadingWebinarId = id;
  },
  setEditWebinarId(state, id) {
    state.editWebinarId = id;
  },
  setIsAddingWebinar(state, webinarState) {
    state.isAddingWebinar = webinarState;
  },
  addToast(state, payload) {
    state.toasts.push({
      message: payload.message,
      options: {
        title: payload.title ? payload.title : "Toast",
        variant: payload.variant ? payload.variant : "info",
        autoHideDelay: 3000,
        appendToast: true,
      },
    });
  },
  addErrorToast(state, payload) {
    const message = payload.error;
    state.toasts.push({
      message: message,
      options: {
        title: "Error",
        variant: "danger",
        autoHideDelay: 3000,
        appendToast: true,
      },
    });
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
